export const databases = {
	mlRequest: 'ml-requests',
	mlSession: 'ml-sessions',
};
